<h2 mat-dialog-title>{{ state === 'editando' ? 'Editando' : 'Creando' }} {{ this.selectedLabel }}</h2>

<mat-dialog-content [formGroup]="attributesForm">

  <!-- Si es EAN -->
  <ng-container *ngIf="selectedAttribute === 'ean'; else defaultFields">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>EAN</mat-label>
      <input matInput formControlName="ean" type="number" />
      <mat-error *ngIf="attributesForm.get('ean')?.hasError('required')">
        El campo EAN es obligatorio
      </mat-error>
      <mat-error *ngIf="attributesForm.get('ean')?.hasError('pattern')">
        Solo se permiten números
      </mat-error>
    </mat-form-field>
  </ng-container>

  <!-- Si es cualquier otro -->
  <ng-template #defaultFields>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="attributesForm.get('name')?.hasError('required')">
        El campo Nombre es obligatorio
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Nombre visible</mat-label>
      <input matInput formControlName="label" />
      <mat-error *ngIf="attributesForm.get('label')?.hasError('required')">
        El campo Nombre visible es obligatorio
      </mat-error>
    </mat-form-field>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="attributesForm.invalid">
    Guardar
  </button>
</mat-dialog-actions>
